export default {
  name: 'oem',
  path: '/oem',
  redirect: '/oem/cloud-education',
  meta: {
    title: 'OEM定制',
    icon: 'icon-oem'
  },
  children: [
    {
      name: 'cloud-education',
      path: 'cloud-education',
      redirect: '/oem/cloud-education/data-sync',
      fullPath: '/oem/cloud-education',
      meta: {
        title: '四川和教育'
      },
      component: () =>
        import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education'),
      children: [
        {
          name: 'data-sync',
          path: 'data-sync',
          fullPath: '/oem/cloud-education/data-sync',
          meta: {
            title: '市镇校数据同步'
          },
          component: () =>
            import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/data-sync')
        },
        {
          name: 'student',
          path: 'student',
          fullPath: '/oem/cloud-education/student',
          meta: {
            title: '学生数据同步'
          },
          component: () =>
            import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/student')
        },
        {
          name: 'student-v2',
          path: 'student-v2',
          fullPath: '/oem/cloud-education/student-v2',
          meta: {
            title: '十牛学生数据同步'
          },
          component: () =>
            import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/student-v2')
        },
        {
          name: 'teacher',
          path: 'teacher',
          fullPath: '/oem/cloud-education/teacher',
          meta: {
            title: '教师数据同步'
          },
          component: () =>
            import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/teacher')
        },
        {
          name: 'open-setting',
          path: 'open-setting',
          fullPath: '/oem/cloud-education/open-setting',
          meta: {
            title: '四川短信开通设置'
          },
          component: () =>
            import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/open-setting')
        },
				{
					name: 'gz-education-data-sync',
					path: 'gz-education-data-sync',
					fullPath: '/oem/cloud-education/gz-education-data-sync',
					meta: {
						title: '贵州和教育'
					},
					component: () =>
						import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/gz-education-data-sync')
				},
        {
          name: 'gz-education-data-sync-school',
          path: 'gz-education-data-sync-school',
          fullPath: '/oem/cloud-education/gz-education-data-sync/school',
          meta: {
            title: '贵州和教育 - 学校同步'
          },
          component: () =>
              import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/gz-education-data-sync/school')
        },
        {
          name: 'gz-education-data-school-sync',
          path: 'gz-education-data-school-sync',
          fullPath: '/oem/cloud-education/gz-education-data-school-sync',
          meta: {
            title: '贵州和教育-学校同步管理'
          },
          component: () =>
              import(/* webpackChunkName: "oem" */ '../../views/oem/cloud-education/gz-education-data-school-sync')
        },{
              name: 'school-log-switch',
              path: 'school-log-switch',
              fullPath: '/oem/cloud-education/school-log-switch',
              meta: {
                  title: '学校日志开控制'
              },
              component: () =>
                  import(/* webpackChunkName: "oem" */ '@/views/oem/cloud-education/school-log-switch')
          },

      ]
    }
  ]
};
